<span class="badge rounded-pill fw-normal" [ngClass]="badgeClass" [ngStyle]="toneStyle">
  <span *ngIf="showDot" class="badge-dot my-jobs-status-dot" [style.background-color]="dotColor || null"></span>
  {{ value }}
</span>
